
app.buttonsController = app.buttonsController || {};
app.buttonsController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */


};

$(document).ready(function(){

});
